// Runtime configuration loader
// This file loads configuration at runtime instead of build time
// allowing the same Docker image to work across multiple environments

const getConfig = () => {
  // First, try to get configuration from window object (injected at runtime)
  if (window.__CONFIG__ && typeof window.__CONFIG__ === 'object') {
    return {
      clientId: window.__CONFIG__.clientId || '',
      authority: window.__CONFIG__.authority || '',
      redirectUri: window.__CONFIG__.redirectUri || '',
      apiBaseUrl: window.__CONFIG__.apiBaseUrl || '',
      apiScope: window.__CONFIG__.apiScope || '',
      environment: window.__CONFIG__.environment || '',
    };
  }

  // Fallback to build-time environment variables (for local development)
  return {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || '',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
    apiScope: process.env.REACT_APP_API_SCOPE || '',
    environment: process.env.REACT_APP_ENVIRONMENT || process.env.ENVIRONMENT || '',
  };
};

// Load configuration
const config = getConfig();

// Validate critical configuration
if (!config.clientId) {
  console.warn('⚠️ Warning: REACT_APP_CLIENT_ID is not configured');
}
if (!config.authority) {
  console.warn('⚠️ Warning: REACT_APP_AUTHORITY is not configured');
}
if (!config.redirectUri) {
  console.warn('⚠️ Warning: REACT_APP_REDIRECT_URI is not configured');
}

// Log configuration (without sensitive data)
console.log('✓ Configuration loaded:', {
  clientId: config.clientId ? `${config.clientId.substring(0, 10)}...` : 'NOT SET',
  authority: config.authority ? 'SET' : 'NOT SET',
  redirectUri: config.redirectUri ? 'SET' : 'NOT SET',
  apiBaseUrl: config.apiBaseUrl ? 'SET' : 'NOT SET',
  apiScope: config.apiScope ? 'SET' : 'NOT SET',
});

export default config;
